import { Image } from '@vueling-ng/vy-ds';

export const emptyImage: Image = {
  src: '',
  alt: ''
};

export const backgroundImage: Image = {
  src: './../../../assets/images/background/background.webp',
  alt: '',
  srcset: './../../../assets/images/background/background.webp'
};
